export const FinalButtonType = {
  none: 'none',
  locked: 'locked',
  finalDayStudent: 'finalDayStudent',
  finalDayStudentWithPopup: 'finalDayStudentWithPopup',
  teacherRegister: 'teacherRegister',
  updateRegistration: 'updateRegistration',
  finalistsList: 'finalistsList',
};
